export const tableTitle = {
  product: 'Producto',
  variant: 'Variante',
  product_type: 'Categoría',
  category: 'Tipo',
  collection: 'Colección',
}
